import type { Feature } from './types';

const title = 'GraphQL API documentation';

const config: Feature<{ defaultTxHash: string | undefined }> = Object.freeze({
  title,
  isEnabled: true,
  defaultTxHash: undefined,
});

export default config;
